import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18LockG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey300,
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("rect", {
        width: 8,
        height: 5.333,
        x: 5,
        y: 7.489,
        rx: 0.612
      }), /*#__PURE__*/jsx("path", {
        d: "M8.911 4.5a3.167 3.167 0 0 1 3.162 2.987l.005.18h-1a2.167 2.167 0 0 0-4.328-.155l-.006.155h-1A3.166 3.166 0 0 1 8.911 4.5"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LockG$1 = Svg18LockG;

export { Svg18LockG$1 as default };
